export const model = {
  mainwarehouse_id: '',
  warehouse_id: '' ,
  user_id: '',
};